module.exports = __webpack_public_path__ + "img/banner2.a56b4d48.png";